// extracted by mini-css-extract-plugin
export default {"root":"TmClassCloud_root__8SdUx"};